// front-end/src/components/block-system/block-configs/block-types/course-module.js

export function createCourseModule(block, parent) {
    const blockName = block.data_block_name;

    // ОТДЕЛЬНАЯ ЛОГИКА ДЛЯ МОДУЛЕЙ КУРСА:
    // Игнорируем order и считаем модули по позиции в DOM
    const existingModules = parent.querySelectorAll('[data-block-name*="course-module-"]');
    const moduleNumber = existingModules.length + 1; // Всегда начинаем с 1

    console.log(`[CourseModule] Creating module ${blockName}`);
    console.log(`[CourseModule] Found ${existingModules.length} existing modules`);
    console.log(`[CourseModule] This will be module number: ${moduleNumber}`);
    console.log(`[CourseModule] Block order from DB: ${block.order} (ignored for display)`);

    const moduleItem = document.createElement('div');
    moduleItem.className = 'accordion-main accordion-map container-fluid';
    moduleItem.setAttribute('data-block-name', blockName);

    if (block.id) {
        moduleItem.setAttribute('data-block-id', block.id);
    }

    // Сохраняем order для БД, но не используем для отображения
    moduleItem.setAttribute('data-order', String(block.order || 0));

    // Добавляем специальный атрибут для номера модуля
    moduleItem.setAttribute('data-module-number', String(moduleNumber));

    if (block.page_id) {
        moduleItem.setAttribute('data-page-id', String(block.page_id));
    }

    moduleItem.style.position = 'relative';

    // Определяем правильный data-page для контента
    let dataPage = 'course-detail'; // fallback

    if (block.page_title) {
        dataPage = block.page_title;
    } else if (window.location.pathname.match(/course-detail(\.html)?$/)) {
        const urlParams = new URLSearchParams(window.location.search);
        const courseSlug = urlParams.get('slug');
        if (courseSlug) {
            dataPage = `Course - ${courseSlug}`;
        }
    } else {
        const bodyPage = document.body.getAttribute('data-page');
        if (bodyPage && bodyPage.startsWith('Course - ')) {
            dataPage = bodyPage;
        }
    }

    console.log(`[CourseModule] Using data-page: ${dataPage} for module ${blockName}`);
    console.log(`[CourseModule] Final module number: ${moduleNumber}`);

    //language=HTML
    moduleItem.innerHTML = `
        <div class="row">
            <div class="col-lg-6 col-md-6 align-content-center">
                <h4 style="margin-bottom: 0;" class="d-none d-md-block head-accordion"
                    data-content="${blockName}-title" data-page="${dataPage}">Модуль ${moduleNumber}</h4>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="row">
                    <div class="col-10 col-lg-10 col-md-10 align-content-center">
                        <h4 style="margin-bottom: 0; align-self: center;" class="d-md-none head-accordion"
                            data-content="${blockName}-title" data-page="${dataPage}">Модуль ${moduleNumber}</h4>
                    </div>
                    <div class="col-2 col-lg-2 col-md-2 d-flex justify-content-end">
                        <img class="open-accordion" src="images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
            </div>
        </div>
        <div class="accordion-inner">
            <p data-content="${blockName}-description" data-page="${dataPage}" data-type="textarea"
               style="white-space: pre-line;">Дізнайтесь про всі види тестування, які ми проводимо</p>
        </div>
    `;

    parent.appendChild(moduleItem);

    // ВАЖНО: После добавления пересчитываем номера всех модулей в секции
    updateAllModuleNumbers(parent);

    return moduleItem;
}

// НОВАЯ ФУНКЦИЯ: Пересчитывает номера всех модулей в секции
function updateAllModuleNumbers(parent) {
    const allModules = parent.querySelectorAll('[data-block-name*="course-module-"]');

    console.log(`[CourseModule] Updating numbers for ${allModules.length} modules`);

    allModules.forEach((module, index) => {
        const correctNumber = index + 1; // 1, 2, 3, 4...

        // Обновляем атрибут
        module.setAttribute('data-module-number', String(correctNumber));

        // Обновляем отображаемый текст в заголовках
        const desktopHeader = module.querySelector('.d-none.d-md-block.head-accordion');
        const mobileHeader = module.querySelector('.d-md-none.head-accordion');

        if (desktopHeader) {
            // Сохраняем оригинальный текст из data-content, но обновляем номер
            const originalText = desktopHeader.textContent;
            const newText = originalText.replace(/Модуль \d+/, `Модуль ${correctNumber}`);
            desktopHeader.textContent = newText;
        }

        if (mobileHeader) {
            const originalText = mobileHeader.textContent;
            const newText = originalText.replace(/Модуль \d+/, `Модуль ${correctNumber}`);
            mobileHeader.textContent = newText;
        }

        console.log(`[CourseModule] Updated module ${module.getAttribute('data-block-name')} to number ${correctNumber}`);
    });
}

// ЭКСПОРТ ФУНКЦИИ для использования в других модулях
export { updateAllModuleNumbers };

export const courseModuleProps = {
    name: 'course-module',
    title: 'Модуль курсу',
    description: 'Блок модуля для програми курсу',
    allowedParents: ['course-modules-section'],
    requiresPage: true,
    contentFields: [
        {name: 'title', type: 'text', label: 'Назва модуля'},
        {name: 'description', type: 'textarea', label: 'Опис модуля'}
    ]
};